import { root } from './checklive';

export const checklive = {
  ...root,
};
